import { Injectable } from "@angular/core";
import { HttpService } from "src/providers/http.service";

@Injectable({
  providedIn: "root"
})
export class InstitutionModel {
  private institution = {
    _id: undefined,
    title: undefined,
    description: undefined,
    cep: undefined,
    address_number: undefined,
    address: undefined,
    radius: undefined,
    color: undefined
  };
  constructor(
    private http: HttpService
  ) { }

  set(data: any) {
    console.log("set", data);
    return new Promise((resolve, reject) => {
      this.institution = {
        _id: data._id,
        title: data.title,
        description: data.description,
        cep: data.cep,
        address_number: data.address_number,
        address: data.address,
        radius: data.radius,
        color: data.color
      };
      sessionStorage.setItem("institution", JSON.stringify(this.institution));
      resolve(true);
    }).catch(err => console.log("Error trying to set new institution: ", err));
  }

  get() {
    return this.institution;
  }

  getAllSearch(data: any = {}) {
    return new Promise((resolve, reject) => {
      this.http.post("api/institution/institution/getAllSearch", true, data).then(res => {
        resolve(res);
      }).catch(err => reject());
    });
  }
}
